import { Icon } from "@albelli/arc-3-react/lib/Icon";
import classnames from "classnames";
import { useHistory } from "components/_hooks/useRouter";
import * as parseurl from "parseurl";
import React from "react";
import { LogoutLink } from "./LogoutLink";

export const MenuLink = ({
  text,
  icon,
  href,
  secondary,
  showArrow,
  items,
  className,
  expanded,
  setExpanded,
  isLogout
}) => {
  const history = useHistory();

  const classes = classnames(
    {
      "link--color-dark-grey": !!secondary && !className,
      "arc3-menu__main__nav__button": !!showArrow
    },
    className
  );

  if (isLogout) {
    return <LogoutLink text={text} className={classes} />;
  }

  const onClick = e => {
    if (!href) return;

    //If the url is a MyAccount url we want to use react router instead of default anchor functionality.
    const parsedHref = parseurl({ url: href });
    if (window.location.hostname === parsedHref.hostname) {
      e.preventDefault();
      //react router only needs what comes after the host
      history.push(parsedHref.path);
    }
  };

  const isExpandable = items && items.length;
  const expand = e => {
    if (isExpandable && setExpanded) {
      setExpanded(text);
      e.preventDefault();
    }
  };
  const collapse = e => {
    if (isExpandable && setExpanded) {
      setExpanded(expanded === text ? false : expanded);
      e.preventDefault();
    }
  };
  const toggleExpand = e => {
    if (isExpandable) {
      expanded !== text ? expand(e) : collapse(e);
    }
  };

  return (
    <a
      className={classes}
      href={href}
      onMouseOver={expand}
      onMouseLeave={collapse}
      onTouchEnd={toggleExpand}
      onClick={onClick}
    >
      {!!icon && <Icon name={icon} />} <span>{text}</span>
      {!!showArrow && !!items && <Icon name="slim_arrow_down" size="small" />}
    </a>
  );
};
export default MenuLink;
